import { SectionModel } from "@src/pages/Promotions/domain/models/CollectionModel";
import { instance } from "./api";
import { requestYandexPublication } from "@src/store/menulist/saga";

interface MatchingProductsParameters {
  menuId: string;
  restaurantId: string;
  sectionId: string;
  page: number;
  searchName?: string;
  limit?: number;
  sortOrder?: string;
}

export const menusApi = {
  patchHasWoltPromo(
    menuId: string,
    hasWoltPromo: boolean,
    restaurantId: string
  ) {
    return instance.patch(`/v2/menu/${menuId}/promo-wolt`, {
      has_promo: hasWoltPromo.toString(),
      restaurant_id: restaurantId,
    });
  },
  getMenusList(restaurantId: string, query: string) {
    return instance.get(`/v3/restaurant/${restaurantId}/menus/status?${query}`);
  },
  getMenuPublicationCount(restaurantId: string) {
    return instance.get(
      `/v3/restaurant/${restaurantId}/available-menu-uploads`
    );
  },
  editMenu(body: any) {
    return instance.put(`/v2/menu/update-info`, body);
  },
  deleteMenu(menuId: string, restaurantId: string) {
    return instance.delete(`/v3/menus/${menuId}?restaurant_id=${restaurantId}`);
  },
  recoveryMenu(menuId: string, restaurantId: string) {
    return instance.patch(
      `/v2/menu/${menuId}/recovery-menu?restaurant_id=${restaurantId}`
    );
  },

  getJsonFile(menuId: string) {
    return instance.get(`/v2/menu/${menuId}/download`);
  },

  uploadJsonFile(menuId: string, jsonFile: any, deliveryService: string) {
    return instance.post(
      `/v2/menu/${menuId}/upload?aggregator=${deliveryService}`,
      jsonFile
    );
  },

  createPosMenu(restaurantId: string, aggregator: string) {
    return instance.post(
      `/v2/menu/restaurant/${restaurantId}/auto-upload?aggregator=${aggregator}`
    );
  },

  autoUpdateMenu(
    menuId: string,
    restaurantId: string,
    body: {
      price: boolean;
      images: boolean;
      name: boolean;
      description: boolean;
    }
  ) {
    return instance.patch(`/v2/menu/auto-update`, body, {
      params: {
        menu_id: menuId,
        restaurant_id: restaurantId,
      },
    });
  },
  getMenuItem(menuId: string, restaurantId: string) {
    return instance.get(`/v2/menu/${menuId}/restaurant/${restaurantId}`);
  },
  getMenuSection(menuId: string) {
    return instance.get<SectionModel[]>(`/v3/menus/${menuId}/sections`);
  },
  getMenuCollections(menuId: string) {
    return instance.get(`/v3/menus/${menuId}/collections`);
  },
  getMenuProducts(
    menuId: string,
    sectionName: string,
    page: number = 1,
    field: string = "price"
  ) {
    return instance.get(
      `/v3/menus/${menuId}/products?section_name=${sectionName}&field=${field}&page=${page}&per_page=${10}`
    );
  },
  getMenuPublictionStatus(menusList: any[]) {
    return instance.post(`v1/menus/verify-upload`, menusList);
  },
  // WOLT DISCOUNT
  runWoltDiscount(menuId: string, restaurantId: string) {
    return instance.post(
      `/v3/menus/${menuId}/run-discount?restaurant_id=${restaurantId}`
    );
  },
  // 1 PAGE UPLOAD MENU
  parseMenu(body: any) {
    return instance.post(`/v1/menus/glovo/parse`, body);
  },
  createMenu(body: any) {
    return instance.post(`/v3/menus/matching-menu`, body);
  },
  uploadMenu(body: any) {
    return instance.post(`/v3/menus/upload`, body);
  },
  uploadExpressMenu(body: any) {
    return instance.post(`/v2/menu/upload-menu/express24`, body);
  },
  updateMenu(token: string) {
    return instance.post(`/v3/menus/update-menu?restaurant_id=${token}`);
  },
  // 2 PAGE MATCH MENU
  // getMenuSections(menuId: string) {
  //   return instance.get(`/v3/menus/${menuId}/sections`);
  // },
  // /v3/menus/upload-menu?restaurant_id=64353894d4ea47b8b592961b&delivery=moysklad
  updateMoyskladMenu(restaurantId: string) {
    return instance.post(
      `/v3/menus/upload-menu?restaurant_id=${restaurantId}&delivery=moysklad`
    );
  },
  getMenuProductsForMatching(params: MatchingProductsParameters) {
    let query = `/v3/menus/${params.menuId}/matching-menu?restaurant_id=${params.restaurantId}`;

    query += `&page=${params.page ?? 1}&limit=${
      params.limit ?? 10
    }&field=price`;

    query += `&sort_order=asc&section_name=${params.sectionId}&name=${
      params.searchName ?? ""
    }`;

    return instance.get(query);
  },
  matchingPorduct(
    menuId: string,
    body: { aggregator_product_id: string; pos_product_id: string }
  ) {
    return instance.put(`/v3/menus/${menuId}/matching-product`, body);
  },
  matchingProduct(body: {
    aggregator_product_id: string;
    pos_product_id: string;
    match: boolean;
    delivery: string;
    menu_id: string;
  }) {
    return instance.put(`/v2/menu/product/matching`, body);
  },
  isMatchedAll(menuId: string, body: { restaurant_id: string }) {
    // return instance.post(`/v3/menus/${menuId}/is-matching`, body);/
  },
  getMenuProduct({
    productId,
    menuId,
    restaurantId,
    restaurantGroupId,
  }: {
    productId: string;
    menuId: string;
    restaurantId: string;
    restaurantGroupId: string;
  }) {
    return instance.get(
      `/v3/menus/${menuId}/product/${productId}?restaurant_id=${restaurantId}&restaurant_group_id=${restaurantGroupId}`
    );
  },
  editProduct(
    menuId: string,
    productId: string,
    restaurantId: string,
    body: any
  ) {
    return instance.put(
      `/v3/menus/${menuId}/product/${productId}?restaurant_id=${restaurantId}`,
      body
    );
  },
  createProduct(menuId: string, body: any) {
    return instance.post(`/v3/menus/${menuId}/product`, body);
  },
  deleteProduct(
    body: { menu_id: string; product_ids: string[] },
    deleteMode: string
  ) {
    return instance.delete(
      `/v2/menu/${body.menu_id}/product?delete_mode=${deleteMode}`,
      {
        data: { product_ids: body.product_ids },
      }
    );
  },
  deleteProducts(
    body: { product_ids: string[]; menu_ids: string[] },
    type: string
  ) {
    return instance.delete(`v2/menu/products/delete?delete_mode=${type}`, {
      data: {
        ...body,
      },
    });
  },
  recoveryProduct({
    menuId,
    productId,
    restaurantId,
    isDeleted = false,
  }: {
    menuId: string;
    productId: string;
    restaurantId: string;
    isDeleted: false;
  }) {
    return instance.patch(
      `/v3/menus/${menuId}/product/${productId}?restaurant_id=${restaurantId}&set_disable=${isDeleted}`
    );
  },
  uploadProductImg(menuId: string, body: any) {
    return instance.put(`/v3/menus/${menuId}/image`, body);
  },
  getAttributeProductList(
    restaurantId: string,
    menuId: string,
    productId: string,
    attributeGroupName: string,
    min: number,
    max: number
  ) {
    return instance.post(
      `/v3/restaurant/${restaurantId}/menu/${menuId}/new-attribute-group?product_id=${productId}&attribute_group_name=${attributeGroupName}&min=${min}&max=${max}`
    );
  },
  editAttributeGroup(restaurantId: string, menuId: string, body: any) {
    return instance.put(
      `/v3/restaurant/${restaurantId}/menu/${menuId}/update-attribute-group`,
      body
    );
  },
  getDefaultAttributes(restaurantId: string, productId: string) {
    return instance.get(
      `/v3/restaurant/${restaurantId}/product/${productId}/attributes`
    );
  },
  addAttributetoAttributeGroup(
    restaurantId: string,
    menuId: string,
    body: any
  ) {
    return instance.put(
      `/v3/restaurant/${restaurantId}/menu/${menuId}/new-attribute-group`,
      JSON.stringify(body)
    );
  },
  getMenuPriceUpdates(menuId: string, restaurantId: string) {
    return instance.get(
      `/menus/${menuId}/get-price-updates?restaurant_id=${restaurantId}`
    );
  },
  editMenuSections(menuId: string, body: any) {
    return instance.put(`/v3/menus/${menuId}/collection`, body);
  },
  getAttributeGroup(
    restaurantId: string,
    menuId: string,
    search: string = "",
    page: number = 1
  ) {
    if (search.trim().length) {
      return instance.get(
        `/v3/menus/${menuId}/attribute-groups-search?param=${search}`
      );
    }

    return instance.get(
      `/v3/restaurant/${restaurantId}/menu/${menuId}/get-attribute-groups?page=${page}`
    );
  },
  getAttributeGroupDetails(
    restaurantId: string,
    menuId: string,
    productId: string,
    attributeGroupId: string
  ) {
    return instance.get(
      `/v3/restaurant/${restaurantId}/menu/${menuId}/get-attribute-group?attribute_group_id=${attributeGroupId}&product_id=${productId}`
    );
  },
  getAttributeGroupProducts(menuId: string, attributeGroupId: string) {
    return instance.get(
      `/v3/menus/${menuId}/attribute-group/${attributeGroupId}/products`
    );
  },
  deleteAttributeGroup(menuId: string, body: any) {
    return instance.delete(`v2/menu/${menuId}/attribute-group/delete`, {
      data: body,
    });
  },
  uploadMenus(body: any) {
    return instance.post(`/v3/menus/upload`, body);
  },
  uploadMenuWolt(body: any) {
    return instance.post(`/v3/menus/upload-wolt`, body);
  },
  uploadMenuYandex(body: any) {
    return instance.post(`/v3/menus/upload-yandex`, body);
  },
  menuValidation(menuId: string) {
    return instance.get(`/v3/menus/${menuId}/health-menu_validation`);
  },
  addExistAttributeGroup(
    menuId: string,
    productId: string,
    attributeGroupId: string
  ) {
    return instance.post(
      `/v3/menus/${menuId}/product/${productId}/add-attribute-group/${attributeGroupId}`
    );
  },
  addMenuCollection(menuId: string, name: string) {
    return instance.post(`/v3/menus/${menuId}/collection`, { name });
  },
  updateMenuCollection(menuId: string, body: any) {
    return instance.put(`/v3/menus/${menuId}/collection`, body);
  },
  deleteMenuCollection(menuId: string, body: any) {
    return instance.patch(`/v3/menus/${menuId}/collection`, body);
  },
  addMenuCategory(menuId: string, body: any) {
    return instance.post(`/v3/menus/${menuId}/section`, body);
  },
  deleteMenuCategory(menuId: string, body: any) {
    return instance.patch(`/v3/menus/${menuId}/section`, body);
  },
  requestYandexPublication(restaurantId: string, groupId: string) {
    return instance.post(`v3/menus/upload`, {
      restaurant_id: restaurantId,
      restaurant_group_id: groupId,
    });
  },
};
